import React from "react"

const LoadingDotsIcon = () => {
  return (
    <div className="dots-loading">
      <div></div>
    </div>
  )
}

export default LoadingDotsIcon
